<template>
  <v-empty-state
    icon="$vuetify.icons.values.organization"
    :label="$t('emptyLabel')"
    :description="$t('emptyDescription')"
  >
    <v-btn depressed color="accent" :to="{ name: 'newOrganization' }">{{ $t('newOrganization') }}</v-btn>
  </v-empty-state>
</template>

<script>
import { VEmptyState } from '@argon/app/components'

export default {
  name: 'NoOrganization',
  components: {
    VEmptyState
  }
}
</script>

<i18n>
{
  "en": {
    "emptyDescription": "By creating an organization you'll be able to collaborate with other people you invite to join.",
    "emptyLabel": "Create Your First Organization",
    "newOrganization": "Create New Organization"
  },
  "fr": {
    "emptyDescription": "En créant une organisation vous pourrez collaborer avec d'autres personnes que vous invitez à rejoindre.",
    "emptyLabel": "Créez votre première organisation",
    "newOrganization": "Créer une nouvelle organisation"
  }
}
</i18n>
